import React from 'react';
import { LockIcon } from '@pushpay/iconography';
import { Menu } from '@pushpay/menu';
import { clsx } from '@pushpay/styles';
import Tooltip from '@pushpay/tooltip';
import { useLink } from '../link-provider';
import { useStyles } from './styles';
const itemClassMap = {
  current: 'currentItem',
  hasAccess: 'activeItem',
  noPermission: 'noAccessItem',
  organizationNoProduct: 'noOrgAccessItem'
};
export const ProductSwitcherItem = ({
  classes: classesProp,
  className: classNameProp,
  icon: ItemIcon,
  productProps,
  tooltips,
  'data-pp-at-target': targetId
}) => {
  const classes = useStyles(classesProp, {
    isMobile: false,
    orgHasProduct: productProps.access !== 'organizationNoProduct'
  });
  const itemClassName = clsx(classes.item, classes[itemClassMap[productProps.access]], classNameProp);
  const icon = /*#__PURE__*/React.createElement(ItemIcon, {
    className: classes.itemIcon,
    "data-pp-at-target": `${targetId}-icon`
  });
  const {
    Link
  } = useLink();

  if (productProps.access === 'current') {
    return /*#__PURE__*/React.createElement(Menu.Item, {
      className: itemClassName,
      "data-pp-at-target": `${targetId}-current`,
      itemValue: productProps.label,
      label: productProps.label,
      leftElement: icon
    });
  }

  if (productProps.access === 'hasAccess') {
    return /*#__PURE__*/React.createElement(Menu.Item, {
      className: itemClassName,
      component: Link,
      "data-pp-at-target": targetId,
      displayStyle: "unstyled",
      href: productProps.url,
      itemValue: productProps.label,
      label: productProps.label,
      leftElement: icon,
      title: productProps.label,
      children: null // eslint-disable-line

    });
  }

  const {
    tooltipContent,
    learnMoreLink,
    description
  } = (() => {
    if (productProps.access === 'noPermission') {
      return {
        tooltipContent: tooltips.noPermission,
        learnMoreLink: null,
        description: null
      };
    }

    return {
      tooltipContent: tooltips.organizationNoProduct,
      learnMoreLink: /*#__PURE__*/React.createElement(Link, {
        className: classes.learnMore,
        href: productProps.learnMoreUrl,
        title: productProps.learnMoreLabel,
        target: "_blank",
        "data-pp-at-target": `${targetId}-learn-more`
      }, productProps.learnMoreLabel),
      description: /*#__PURE__*/React.createElement("div", {
        className: classes.noAccessDescription
      }, productProps.description)
    };
  })();

  const baseNoAccessTargetId = `${targetId}-no-access`;
  const label = /*#__PURE__*/React.createElement("div", {
    className: classes.noAccessLabel
  }, productProps.label, /*#__PURE__*/React.createElement(Tooltip, {
    classes: {
      root: classes.noAccessTooltipContainer,
      tooltip: classes.noAccessTooltipPanel,
      content: classes.noAccessTooltipPanelContent
    },
    content: tooltipContent,
    placement: "top",
    panelSpace: "XXSMALL",
    "data-pp-at-target": `${baseNoAccessTargetId}-tooltip`
  }, /*#__PURE__*/React.createElement(LockIcon, {
    className: classes.noOrgAccessLockIcon,
    displaySize: "large",
    "data-pp-at-target": `${baseNoAccessTargetId}-icon`
  })));
  return /*#__PURE__*/React.createElement(Menu.Item, {
    className: itemClassName,
    leftElement: icon,
    rightElement: learnMoreLink,
    itemValue: productProps.label,
    disableSelection: true,
    label: label,
    "data-pp-at-target": baseNoAccessTargetId
  }, description);
};